export function formatMoney(val) {

    if(val === 0 || val === '0')
        return '0';

    if(!val) {
        return '';
    }

    val = String(val).replace(/^0+/, "");
    let amount = val.replace(/[^-\d.,]/, '').replace(',', '.').split('.');
    let _split = amount[0];
    if(amount.length > 1)
        _split += '.' + amount[1];
    return _split;
}